export default __webpack_public_path__ + "static/media/visfitlogo.e926c225.jpeg";